<template>
  <div class="left-association">
    <h1>{{title}}</h1>
    <span>{{remarks||'未设置'}}</span>
    <!-- <div class="t1">{{title}}</div> -->
    <div class="like"></div>
  </div>
</template>
<script>
export default {
  props: ["title", 'remarks'],
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.left-association {
  box-sizing: border-box;
  width: 332px;
  padding-left: 35px;
  > h1 {
    color: rgba(0, 0, 0, 1);
    font-size: 28px;
    box-sizing: border-box;
    padding-left: 18px;
  }
  > span {
    display: inline-block;
    padding-top: 5px;
    color: rgba(120, 120, 120, 1);
    font-size: 20px;
    text-align: left;
    line-height: 25px;
    margin-top: 17px;
    box-sizing: border-box;
    padding-left: 18px;
  }
  .t1 {
    margin-top: 41px;
    color: rgba(16, 16, 16, 1);
    font-size: 28px;
  }
  .like{
    margin-top: 40px;
    width: 293px;
    height: 1px;
    background-color: rgba(187, 187, 187, 1);
  }
}
</style>